export default "__VITE_ASSET__CdGHFbqZ__"